import { common } from '@tencent/ceiba-base-components';
import axios from 'axios';

// 初始化requestInstance

let baseURL = 'https://agw-t.xinyue.qq.com';
if (typeof window !== 'undefined' && window.CEIBA_API_HOST) {
  baseURL = window.CEIBA_API_HOST;
}
const requestInstance = axios.create({
  baseURL,
  timeout: 10000, // request timeout
  withCredentials: true,
});

function getAuthorization() {
  const acctype = common.tool.getCookie('acctype');
  if (!acctype) {
    const uin = common.tool.getCookie('uin');
    const skey = common.tool.getCookie('skey');
    if (!uin || !skey) {
      return {};
    }
    return {
      'T-OPENID': uin.replace(/^[0o]+/, ''),
      'T-APPID': '',
      'T-ACCESS-TOKEN': skey,
      'T-ACCOUNT-TYPE': 'qq',
    };
  }

  return {
    'T-OPENID': common.tool.getCookie('openid'),
    'T-APPID': common.tool.getCookie('appid'),
    'T-ACCESS-TOKEN': common.tool.getCookie('access_token'),
    'T-ACCOUNT-TYPE': common.tool.getCookie('acctype'),
  };
}

requestInstance.interceptors.request.use((config) => {
  const newConfig = config;
  newConfig.headers = {
    ...config.headers,
    'T-MODE': 'true',
    'T-DEVICE-TYPE': common.platform.device,
    ...getAuthorization(),
  };
  return newConfig;
});

requestInstance.interceptors.response.use(response => response.data);

// axiosInstance 不带特殊逻辑的裸axios
const axiosInstance = axios.create({
  baseURL,
  timeout: 10000, // request timeout
  withCredentials: true,
});


axiosInstance.interceptors.response.use(response => response.data);

export default {
  install(Vue) {
    Vue.prototype.$requestInstance = requestInstance;
    Vue.prototype.$axiosInstance = axiosInstance;
  },
};

